import React from "react";
import {observer} from "mobx-react-lite";
import {Box, IconButton, Stack, Tooltip} from "@mui/material";
import {Refresh, ReceiptLongOutlined} from "@mui/icons-material";
import {useStores} from "~/stores";
import {CurrencyComponent} from "~/components/currency-component/CurrencyComponent";
import {StatChip} from "~/components/StatChip/StatChip";
import {COLORS} from "~/style/colors-ts";
import ChartIcon from "~/icons/svg/ChartIcon.svg?react";
import DbIcon from "~/icons/svg/DbIcon.svg?react";
import DollarCoinIcon from "~/icons/svg/DollarCoinIcon.svg?react";

const numberFormat = new Intl.NumberFormat();

/**
 * The counts row: categories, spend, suppliers and transactions in the current filters, plus refresh. The chips and
 * colours are those of Explore Categories (`StatChip`).
 */
export const SpendLandscapeKpis: React.FC = observer(() => {
    const {bagStore} = useStores();
    const kpi = bagStore.advanced.kpi;
    const items: {key: string, label: string, icon: React.ReactElement, color: string, value: React.ReactNode}[] = [
        {
            key: 'categories', label: 'Categories', icon: <ChartIcon/>, color: COLORS.secondary.main,
            value: kpi ? numberFormat.format(kpi.n_categories || 0) : '-',
        },
        {
            key: 'spend', label: 'Spend', icon: <DollarCoinIcon/>, color: COLORS.success.main,
            value: kpi ? <CurrencyComponent v={kpi.total_spend}/> : '-',
        },
        {
            key: 'suppliers', label: 'Suppliers', icon: <DbIcon/>, color: COLORS.info.main,
            value: kpi ? numberFormat.format(kpi.n_suppliers || 0) : '-',
        },
        {
            key: 'transactions', label: 'Transactions', icon: <ReceiptLongOutlined/>, color: COLORS.primary.main,
            value: kpi ? numberFormat.format(kpi.total_transactions || 0) : '-',
        },
    ];
    return <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1} className="spend-landscape-kpis">
        {items.map(item =>
            <Box key={item.key} data-testid={`kpi-${item.key}`}>
                <StatChip icon={{element: item.icon, color: item.color}} title={item.label} value={item.value}/>
            </Box>
        )}
        <Box sx={{flexGrow: 1}}/>
        <Tooltip title="Refresh data">
            <span>
                <IconButton
                    size="small"
                    aria-label="refresh"
                    disabled={bagStore.advanced_job.already_running ?? true}
                    onClick={() => bagStore.advanced_job.createRecalculation()}>
                    <Refresh/>
                </IconButton>
            </span>
        </Tooltip>
    </Stack>;
});
